export const MISSING_NOTIFICATION_TARGET = "This item is no longer available";

export type NotificationTarget = {
  targetType: string;
  targetId?: string | null;
  engagementId?: string | null;
};

export function notificationPath(target: NotificationTarget): string | null {
  const engagementId = target.engagementId?.trim();
  if (!engagementId) {
    return null;
  }

  const targetId = target.targetId?.trim();
  switch (target.targetType) {
    case "Task":
      return targetId
        ? `/workflow/${engagementId}?taskId=${encodeURIComponent(targetId)}`
        : null;
    case "Process":
      return targetId
        ? `/workflow/${engagementId}?processId=${encodeURIComponent(targetId)}`
        : null;
    case "Workflow":
      return `/workflow/${engagementId}`;
    case "Request":
      return targetId
        ? `/requests/${engagementId}?requestId=${encodeURIComponent(targetId)}`
        : null;
    default:
      return null;
  }
}
